/**
 * Version Popup Utils
 * Common functionality for version popup interceptors
 */

import { HttpResponse } from '@angular/common/http';
import type { Response } from 'auth';
import { environment } from '../../../environments/environment';

export const API_VERSION_HEADER_KEY: string = 'x-api-v2-version';

/**
 * Check if URL is an API request
 */
export function isApiRequest(url: string): boolean {
	return url.includes(environment.CS_URLS.API_DOMAIN);
}

/**
 * Get version header from different response types
 */
function getVersionHeader(response: HttpResponse<any> | Response<any> | any): string | null {
	// Handle Angular HttpResponse
	if (response instanceof HttpResponse) {
		return response.headers.get(API_VERSION_HEADER_KEY);
	}

	// Handle fetch Response
	if (response instanceof Response) {
		return response.headers[API_VERSION_HEADER_KEY];
	}

	// Handle axios response
	if (response && response.headers) {
		return response.headers[API_VERSION_HEADER_KEY.toLowerCase()] || response.headers[API_VERSION_HEADER_KEY] || null;
	}

	return null;
}

/**
 * Process API response for Version Handler and trigger version popup if needed
 */
export function responseVersionHandler(event: HttpResponse<any> | Response<any>): void {
	const currentHeader = sessionStorage.getItem(API_VERSION_HEADER_KEY);

	const newHeader = getVersionHeader(event);

	// If the header is not found or the header is the same as the current header, do not process the response
	if (!newHeader || newHeader === currentHeader) {
		return;
	}

	// Store the new version
	sessionStorage.setItem(API_VERSION_HEADER_KEY, newHeader);

	// If there was no version header for comparison, No popup should be shown
	if (!currentHeader) {
		return;
	}

	// Dispatch event to notify React hooks
	window.dispatchEvent(new StorageEvent('storage', {
		key: API_VERSION_HEADER_KEY,
		newValue: newHeader,
		oldValue: currentHeader,
		storageArea: sessionStorage,
		url: window.location.href || '',
	}));
}

